import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Shield } from "@phosphor-icons/react";

const STARTER_GRADIENTS = [
  "from-[#1a1a1a] to-[#0a0a0a]",
  "from-[#1c1408] to-[#0a0a0a]",
  "from-[#0c1414] to-[#0a0a0a]",
  "from-[#181818] to-[#050505]",
];

export default function ProductCard({ product, idx = 0 }) {
  const isFlagship = product.is_flagship;
  const gradient = STARTER_GRADIENTS[idx % STARTER_GRADIENTS.length];

  if (isFlagship) {
    return (
      <Link
        to={`/products/${product.slug}`}
        data-testid={`product-card-${product.id}`}
        className="armor-border surface-card group block p-6 lg:p-8 relative overflow-hidden col-span-1 md:col-span-2"
        style={{ minHeight: "420px" }}
      >
        <div className="absolute inset-0 opacity-30 group-hover:opacity-50 transition-opacity">
          <img src={product.image} alt="" className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/80 to-transparent" />

        <div className="relative z-10 h-full flex flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-4">
              <span className="overline text-[#FFD700]">// Flagship</span>
              <Shield size={20} weight="duotone" className="text-[#FFD700]" />
            </div>
            <h3 className="heading-display text-3xl md:text-4xl mb-3 text-white">
              {product.title}
            </h3>
            <p className="text-sm text-white/70 max-w-md font-light">{product.tagline}</p>
          </div>
          <div className="flex items-end justify-between mt-8">
            <div>
              <div className="overline text-white/40 mb-1">Provision Rate</div>
              <div className="flex items-baseline gap-2">
                <span className="font-mono text-2xl text-[#FFD700] font-bold">${product.price_usd}</span>
                {product.is_subscription && product.subscription_price_usd && (
                  <span className="font-mono text-xs text-white/60">
                    + ${product.subscription_price_usd}{product.subscription_label || "/mo"}
                  </span>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-white group-hover:text-[#FFD700] transition-colors">
              Engage
              <ArrowUpRight size={16} weight="bold" />
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.id}`}
      className={`surface-card group block p-6 relative overflow-hidden bg-gradient-to-br ${gradient}`}
    >
      <div className="absolute inset-0 tactical-grid opacity-20" />
      <div className="relative z-10 h-full flex flex-col">
        <div className="flex items-center justify-between mb-6">
          <span className="overline text-[0.6rem] text-[#FFD700]/80">// Starter</span>
          <div className="font-mono text-[0.6rem] text-white/30 tracking-widest">#{String(idx + 1).padStart(2, "0")}</div>
        </div>

        <div className="overline text-white/40 text-[0.55rem] mb-2">{product.category}</div>
        <h3 className="text-lg font-bold text-white leading-tight mb-3 group-hover:text-[#FFD700] transition-colors min-h-[3rem]">
          {product.title.replace(" | Sovereign Starter", "")}
        </h3>

        <p className="text-xs text-white/50 font-light leading-relaxed line-clamp-2 mb-6 flex-grow">
          {product.tagline}
        </p>

        <div className="flex items-end justify-between pt-4 border-t border-white/5">
          <div>
            <div className="font-mono text-base text-[#FFD700] font-bold">${product.price_usd}</div>
            {product.is_subscription && product.subscription_price_usd && (
              <div className="font-mono text-[0.55rem] text-white/50 mt-0.5">
                + ${product.subscription_price_usd}{product.subscription_label || "/mo"}
              </div>
            )}
          </div>
          <ArrowUpRight size={16} weight="bold" className="text-white/40 group-hover:text-[#FFD700] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
        </div>
      </div>
    </Link>
  );
}
